import { cn } from "admin-ui/utils/cn"

import { IconProps } from "."

export default function FilledGrayPaper({
  className,
  transform,
  ...reset
}: Readonly<IconProps>) {
  return (
    <svg
      width="22"
      height="30"
      viewBox="0 0 22 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("h-6 w-6", className)}
      transform={transform}
      {...reset}
    >
      <g clipPath="url(#clip0_6007_180577)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.84243 0H13.6595L21.967 8.86861V26.0912C21.967 28.2482 20.2648 30 18.1558 30H3.84243C1.74413 30 0.03125 28.2482 0.03125 26.0912V3.8978C0.0312129 1.75181 1.74413 0 3.84243 0Z"
          fill="#A1A1AA"
        />
        <path
          opacity="0.7"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.6484 0V8.79197H21.9667L13.6484 0Z"
          fill="#E4E4E7"
        />
      </g>
      <defs>
        <clipPath id="clip0_6007_180577">
          <rect width="22" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
